import {
  buildCollection,
  buildEntityCallbacks,
  buildProperty,
  type EntityIdUpdateProps,
} from "@firecms/core";
import type { AuthExtras } from "../types/auth";

export type ManagerRole = "manager" | "locked";

export type Manager = {
  uid: string;
  role: ManagerRole;
};

const managersCallbacks = buildEntityCallbacks({
  onIdUpdate({ values }: EntityIdUpdateProps): string {
    return values?.uid || "Select a user";
  },
});

export const managersCollection = buildCollection<Manager>({
  name: "Managers",
  singularName: "Manager",
  description:
    "Super administrators who can manage other super admins and create client accounts.",
  id: "managers",
  path: "managers",
  icon: "SupervisorAccount",
  group: "Admin",
  permissions: ({ authController }) => {
    const extra = authController.extra as AuthExtras | undefined;
    const canManage = extra?.isSuperManager === true;
    return {
      read: canManage,
      edit: canManage,
      create: canManage,
      delete: canManage,
    };
  },
  properties: {
    uid: buildProperty({
      name: "User ID",
      dataType: "string",
      validation: { required: true },
      description: "Firebase Auth uid.",
    }),
    role: buildProperty({
      name: "Role",
      dataType: "string",
      validation: { required: true },
      enumValues: {
        manager: "Manager",
        locked: "Locked",
      },
    }),
  },
  callbacks: managersCallbacks,
});
